import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
    Alert,
    Box,
    Button,
    Stack,
    Typography,
} from '@mui/material';

/**
 * Edition-limited message shown when a deferred route is blocked for wedge personas.
 *
 * @param {object} props
 * @param {string} [props.featureName] - User-facing feature label.
 */
export const DeliveryCockpitEditionBlocked = ({
    featureName = 'This capability',
}) => (
    <Box sx={{ p: 3, maxWidth: 720, mx: 'auto' }} data-testid="delivery-cockpit-edition-guard" data-deferred-feature-guard>
        <Alert severity="info" sx={{ mb: 2 }}>
            <Typography variant="subtitle2" component="div" gutterBottom>
                Not included in Delivery Cockpit
            </Typography>
            <Typography variant="body2">
                {featureName} is part of a future enterprise edition. Your current
                workspace covers project delivery, timesheets, staffing, and billing.
            </Typography>
        </Alert>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            <Button
                variant="contained"
                size="small"
                component={RouterLink}
                to="/project-operations"
            >
                Delivery cockpit
            </Button>
            <Button
                variant="outlined"
                size="small"
                component={RouterLink}
                to="/invoice-management"
            >
                Billing &amp; invoices
            </Button>
            <Button
                variant="text"
                size="small"
                component={RouterLink}
                to="/timesheets"
            >
                Timesheets
            </Button>
        </Stack>
    </Box>
);
